import { giphyLightCharcoal } from '@giphy/colors'
import { ControlSize } from 'types'
import { IconComponent } from 'ui'
import { heightFromControlSize } from 'utils'
import { Avatar, Container, NoAvatar } from './style'

type Props = {
    className?: string
    loading?: boolean
    size: ControlSize
    source?: string
}

const UsernameFieldAvatar = ({ className, loading = false, size, source = '' }: Props) => {
    const iconSize = Math.round(heightFromControlSize(size) / 2)

    function getComponent() {
        if (loading) {
            return <NoAvatar $loading />
        }

        if (source) {
            return <Avatar alt="" src={source} />
        }

        return (
            <NoAvatar>
                <IconComponent color={giphyLightCharcoal} icon="user" height={iconSize} width={iconSize} />
            </NoAvatar>
        )
    }

    return (
        <Container $size={size} className={className}>
            {getComponent()}
        </Container>
    )
}

export default UsernameFieldAvatar
